import { useQuery } from 'react-query'
import { getPositionsForRecommendations } from './api'
import { useSelector } from 'react-redux'
import { hiringTeamId as hiringTeamIdSelector, memberProfileId as memberProfileIdSelector } from '@/core/selectors/currentUser'
import { buildPositionsRecommendationsListCacheKey } from '@/core/helpers/recommendationsCardsCacheHelpers'

export const useFetchRecommendationsPositions = () => {
  const hiringTeamId = useSelector(hiringTeamIdSelector)
  const memberProfileId = useSelector(memberProfileIdSelector)

  const {
    data: { hiringTeam: { positions: { nodes: activePositions = [] } = {} } = {} } = {},
    isLoading,
    isError,
  } = useQuery(
    buildPositionsRecommendationsListCacheKey({ hiringTeamId }),
    () => getPositionsForRecommendations({ hiringTeamId, memberProfileId }),
    { refetchOnWindowFocus: false },
  )

  const positionsOrderedByTotalCount = activePositions.sort(
    (a, b) => (b?.recommendationCandidateCards?.totalCount ?? 0) - (a?.recommendationCandidateCards?.totalCount ?? 0),
  )

  const recommendationListCount = activePositions.reduce(
    (acc, position) => acc + (position?.recommendationCandidateCards?.totalCount ?? 0),
    0,
  )

  return { positions: positionsOrderedByTotalCount, recommendationListCount, isLoading, isError }
}
